// vue路由
import Vue from 'vue';
import Router from 'vue-router';
const live = () => import('@/page/live/index');
Vue.use(Router)

let router = new Router({
	// mode: 'history',
	mode: 'hash',
  routes: [
    { 
      path: '/',
      name: 'live',
      component: live
    }
  ]
})
//路由拦截器
router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    // sessionStorage.removeItem('user');
    localStorage.removeItem('user');
  }
  next();
  // console.log('路由拦截');
  // token
  // let token = localStorage.getItem("token");
  // if (!token && to.token != '/login') {
  //   next({ path: '/login' })
  // } else {
  //   next()
  // }
  //用户信息
  // let user = JSON.parse(sessionStorage.getItem('user'));
  // if (!user && to.path != '/login') {
  //   next({ path: '/login' })
  // } else {
  //   next()
  // }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js